import { styled } from 'styled-components'

export const Date = styled.p`
    font-family: var(--primary-font-family);
    font-size: 20px;
    font-weight: 900;
    line-height: 27px;
    color: #EB5577;
    padding: 2px 0 2px 0;
`